import { render, staticRenderFns } from "./SubscriptionOverview.vue?vue&type=template&id=8678dbbc"
import script from "./SubscriptionOverview.vue?vue&type=script&lang=js"
export * from "./SubscriptionOverview.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionOverview.vue?vue&type=style&index=0&id=8678dbbc&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports